import Icon from "@bokio/designsystem/components/Icon/Icon";
import { mergeClassNames } from "@bokio/utils/classes";

import type { ReactNode } from "react";

import * as styles from "./info.scss";

interface InfoProps {
	children: ReactNode;
	className?: string;
	testId?: string;
}

const Info = ({ children, className, testId }: InfoProps) => {
	return (
		<small className={mergeClassNames(styles.info, className)} data-testid={testId}>
			<Icon name="info" className={styles.infoIcon} size="14" />
			<span>{children}</span>
		</small>
	);
};

export default Info;
